import React from 'react'
import { userAtom } from '../atoms/globalStates';
import {useAtom} from 'jotai'
import { useLocation, Navigate } from 'react-router-dom';


const AdminOnly  = ({ children }) => {
    
    const user = JSON.parse(localStorage.getItem("user"));
    let location = useLocation();



    if (user?.roleName.toUpperCase()!=='ADMIN') {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
  };

export default AdminOnly
